import { QuickActionsEncounterQueryOptions } from "../types";
import { BuildQueryParams } from "./patient-log";

export const quickActionsKeys = {
    all: ["todos"] as const,
    todos: (program?: string) => [...quickActionsKeys.all, program] as const,
    refills: () => [...quickActionsKeys.all, "refills"] as const,
    todayEncounters : (opts: QuickActionsEncounterQueryOptions) => [...quickActionsKeys.all, "encounters", "today", opts] as const,
    todayEncounterRefills: (opts: QuickActionsEncounterQueryOptions) => [...quickActionsKeys.all, "encounters", "today",  "refills", opts] as const,
    appointmentById: (id: string) => [...quickActionsKeys.all, "today", "encounters", id] as const,
    refillsById: (id: string) => [...quickActionsKeys.refills(), id] as const,
    // THIS IS THE PATIENT LOG KEYS
    patientLog: ["quick-actions-patient_log"] as const,
    patientLogById: (id: string) => [...quickActionsKeys.patientLog, id] as const,
    patientLogByTimeline: (id: string) => [...quickActionsKeys.patientLogById(id), "timeline"] as const,
    patientLogByMedication: (id: string) => [...quickActionsKeys.patientLogById(id), "medication"] as const,
    patientLogByPaymentHistory: (id: string, params: BuildQueryParams) => [...quickActionsKeys.patientLogById(id), "payment_history", params] as const,
    patientLogByMedicalPlan: (id: string) => [...quickActionsKeys.patientLogById(id), "medical_plan"] as const,
    patientLogByQuestionaire: (id: string) => [...quickActionsKeys.patientLogById(id), "questionnaire"] as const,
    patientLogByNotes: (id: string, params: BuildQueryParams) => [...quickActionsKeys.patientLogById(id), "notes", params] as const,
  } as const;

